import { ProjectFilesProvider } from "files/hooks/useProjectFilesContext";
import { useProjectContext } from "~/pages/manifold-nextgen/components/projects/useProjectContext";
import { nextgenProjectFilesPath } from "~/pages/manifold-nextgen/paths";
import { EmbeddedFiles } from "./EmbeddedFiles";

export const ProjectFiles = () => {
  const { projectId, project } = useProjectContext();
  return (
    <ProjectFilesProvider
      value={{ projectId: project.id, basePath: nextgenProjectFilesPath(projectId) }}
    >
      <EmbeddedFiles />
    </ProjectFilesProvider>
  );
};
